import GanttViewProps from './Views'

let KendoGanttView = {
    name: 'kendo-gantt-view',
    render () {
        return null
    },
    mixins: [GanttViewProps]
}

export default KendoGanttView


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGanttView/index.js